import * as React from 'react'

function useComponentWidth(ref) {
  const [width, setWidth] = React.useState(0)

  // eslint-disable-next-line
  React.useEffect(() => {
    const newWidth = ref?.current?.clientWidth || 0
    if (newWidth !== width) setWidth(newWidth)
  })

  return width
}

export default useComponentWidth
